export const networks: any = {
	erc20: { name: 'Ethereum', color: '#979695', icon: '/icons/networks/erc20.png' },
	bep20: { name: 'BSC', color: '#f0b90c', icon: '/icons/networks/bep20.png' },
	polygon: { name: 'Polygon', color: '#8247e5', icon: '/icons/networks/polygon.png' },
	avalanche: { name: 'Avalanche', color: '#e84142', icon: '/icons/networks/avalanche.png' },
	moonbeam: { name: 'Moonbeam', color: '#5eccc8', icon: '/icons/networks/moonbeam.png' },
	moonriver: { name: 'Moonriver', color: '#f2b706', icon: '/icons/networks/moonriver.png' },
	mantle: { name: 'Mantle', color: '#f2b706', icon: '/icons/networks/mantle.png' },
};

export const networkIcons: any = {
	ethereum: '/icons/erc20.png',
	'avalanche-2': '/icons/avalanche.png',
	'matic-network': '/icons/polygon.png',
	binancecoin: '/icons/bep20.png',
	moonbeam: '/icons/moonbeam.png',
	moonriver: '/icons/moonriver.png',
	mantle: '/icons/mantle.png',
};
